import { z } from "zod";
export const ColorSchemeIdSchema = z.union([
    z.literal("natural"),
    z.literal("pastelish"),
    z.literal("professional-blue"),
    z.literal("minimalist"),
    z.literal("playful"),
    z.literal("cyberish"),
    z.literal("neutral"),
    z.literal("pink"),
    z.literal("violet"),
    z.literal("blue"),
    z.literal("emerald"),
    z.literal("yellow"),
    z.literal("red"),
    z.literal("stackje-brand"),
    z.literal("custom"),
]);
export const ColorScheme = {
    natural: ["yellow-50", "lime-800", "lime-500", "slate-50", "green-950"],
    pastelish: ["amber-950", "fuchsia-50", "orange-100", "pink-200", "violet-950"],
    "professional-blue": ["blue-900", "sky-400", "slate-100", "white", "blue-900"],
    minimalist: ["zinc-950", "gray-700", "gray-100", "white", "blue-50"],
    playful: ["rose-400", "sky-300", "yellow-400", "slate-50", "slate-950"],
    cyberish: ["lime-300", "lime-200", "indigo-700", "stone-50", "slate-950"],
    neutral: ["neutral-50", "neutral-200", "neutral-500", "neutral-700", "neutral-950"],
    pink: ["pink-50", "pink-200", "pink-500", "pink-700", "pink-900"],
    violet: ["violet-50", "violet-200", "violet-500", "violet-700", "violet-950"],
    blue: ["blue-50", "blue-200", "blue-500", "blue-700", "blue-950"],
    emerald: ["emerald-50", "emerald-200", "emerald-500", "emerald-700", "emerald-950"],
    yellow: ["yellow-50", "yellow-200", "yellow-500", "yellow-700", "yellow-950"],
    red: ["red-50", "red-200", "red-500", "red-700", "red-900"],
    "stackje-brand": ["stackje-brand-50", "stackje-brand-200", "stackje-brand-500", "stackje-brand-800", "stackje-brand-950"],
    custom: [], // Placeholder - custom colors are handled separately
};
export const ColorSchemeLabels = {
    natural: "Natural",
    pastelish: "Pastelish",
    "professional-blue": "Professional Blue",
    minimalist: "Minimalist",
    playful: "Playful",
    cyberish: "Cyberish",
    neutral: "Neutral",
    pink: "Pink",
    violet: "Violet",
    blue: "Blue",
    emerald: "Emerald",
    yellow: "Yellow",
    red: "Red",
    "stackje-brand": "Stack.je Brand",
    custom: "✨ Custom",
};
